import { lazy } from "react";
import { PATHS } from "@/lib/router";
import { FeatureProvider } from "@/lib/i18n";
import { Feature_NAMESPACES } from "@/lib/i18n";
const ActivityLogPage = lazy(() => import("./pages/ActivityLogPage"));

export const activityLogRoutes = [
  {
    path: PATHS.ACTIVITY_LOG,
    element: (
      <FeatureProvider namespace={Feature_NAMESPACES.ACTIVITY_LOG}>
        <ActivityLogPage />
      </FeatureProvider>
    ),
    handle: {
      permission: { resource: "activity_log", action: "view" },
      defaultView: true,
    },
  },
];
